import { render } from "./Meeting.vue?vue&type=template&id=961f36d8"
import script from "./Meeting.vue?vue&type=script&lang=js"
export * from "./Meeting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__